import React from "react";

import styles from "./ScheduleList.module.scss";
import { DaySchedule } from "../../types/interfaces";

const DAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const formatTime = (t: string): string => {
  const [h, m] = t.split(":");
  return `${Number(h)}:${m}`;
};

interface Props {
  schedule: DaySchedule[];
}

const getTodayStatus = (schedule: DaySchedule[]) => {
  const jsDay = new Date().getDay();
  const seq = jsDay === 0 ? 7 : jsDay;

  const today = schedule.find((d) => d.sequence === seq);
  if (!today || today.dayOff) return { open: false, text: "Сегодня выходной" };

  const now = new Date();
  const [fh, fm] = today.from.split(":").map(Number);
  const [th, tm] = today.to.split(":").map(Number);
  const fromMin = fh * 60 + fm;
  const toMin = th * 60 + tm;
  const nowMin = now.getHours() * 60 + now.getMinutes();

  const fromText = formatTime(today.from);
  const toText = formatTime(today.to);

  if (nowMin < fromMin) return { open: false, text: `Откроется в ${fromText}` };
  if (nowMin > toMin) return { open: false, text: `Закрыто до ${toText}` };
  return { open: true, text: `Открыто до ${toText}` };
};

export const ScheduleList: React.FC<Props> = ({ schedule }) => {
  const status = getTodayStatus(schedule);
  const jsDay = new Date().getDay();
  const todaySeq = jsDay === 0 ? 7 : jsDay;

  const sorted = [...schedule].sort((a, b) => a.sequence - b.sequence);

  return (
    <div className={styles.Wrapper}>
      <div className={styles.StatusWrapper}>
        <span className={styles.StatusBg} aria-hidden="true">
          {status.text}
        </span>
        {/* <span
          className={`${styles.Status} ${status.open ? styles.Open : styles.Closed}`}
        >
          {status.text}
        </span> */}
      </div>

      <ul className={styles.Schedule}>
        {sorted.map((d) => {
          const isToday = d.sequence === todaySeq;
          return (
            <li
              key={d.sequence}
              className={`${styles.Row} ${isToday ? styles.Today : ""}`}
            >
              <span className={styles.Day}>
                {DAYS[d.sequence - 1] || ""}
                {isToday && <span className={styles.TodayMark}>сегодня</span>}
              </span>
              <span
                className={`${styles.Time} ${d.dayOff ? styles.DayOff : ""}`}
              >
                {d.dayOff
                  ? "Выходной"
                  : `${formatTime(d.from)} — ${formatTime(d.to)}`}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
